import React from "react";
import { Box, Grid, Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useSelector } from "react-redux";
import PDFViewer from "../../../../components/ui/PDFViewer";
import { RootState } from "../../../../services/redux/store";

type Props = {
  open: boolean;
  isXsOrSm: boolean;
  viewDocUrl: string;
  viewDocMimeType: string;
  onClose: () => void;
};

export function DocumentPreviewModal({
  open,
  isXsOrSm,
  viewDocUrl,
  viewDocMimeType,
  onClose,
}: Props) {
  const partnerStartedJourney = useSelector(
    (state: RootState) => state.stepper.partnerStartedJourney
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isXsOrSm ? "300px" : "80%",
          minHeight: isXsOrSm ? "380px" : "90%",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
        }}
      >
        <Close
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            cursor: "pointer",
          }}
        />

        <Grid container spacing={2} sx={{ paddingBottom: "20px" }}>
          <Grid item xs={12}>
            <div
              className="image-container"
              style={{
                border: "1px solid #ddd",
                padding: "10px",
                minWidth: isXsOrSm ? "300px" : "100%",
                height: isXsOrSm ? "320px" : "80vh",
                overflow: "auto",
                marginTop: "39px",
              }}
            >
              {viewDocMimeType?.includes("pdf") || viewDocUrl?.includes("pdf") ? (
                <PDFViewer
                  pdfUrl={viewDocUrl}
                  partnerStartedJourney={partnerStartedJourney}
                />
              ) : (
                <img src={viewDocUrl} alt="document" />
              )}
            </div>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

